
const api = {
    fetchPolicyByDomain(domainName,axiosInstance) {
        return axiosInstance.get('/v1/passwordpolicies/'+domainName);
    },
    changePassword(requestBody,axiosInstance) {
        return axiosInstance.post('/v1/changepassword', requestBody, {
            withCredentials: true, // If true, will forward a server cookie.
        });
    }
};
export default api;